export default __webpack_public_path__ + "static/screenshot-ea21cb87b2da1391266275336d42cb63.png";